import {useCallback, useState} from 'react';
import {StatusModalStates} from 'components/StatusModal';
import {CoreError} from '@guestapp/sdk';
import {StripeError} from '@stripe/stripe-js';
import {useTimeoutRef} from '@guestapp/core';

const SuccessModalTimeoutMs = 2800;
const LoadingModalTimeoutMs = 1500;

type Props = {
  onSuccess: () => void;
};
export const usePaymentProcessingState = ({onSuccess}: Props) => {
  const [processState, setProcessState] = useState(StatusModalStates.IDLE);
  const [error, setError] = useState<string>();
  const loadingModalTimeoutRef = useTimeoutRef();
  const successModalTimeoutRef = useTimeoutRef();

  const closeProcessingModal = useCallback(() => {
    setProcessState(StatusModalStates.IDLE);
    setError('');
  }, []);

  const onLoadingModal = () => {
    return new Promise<void>(resolve => {
      setProcessState(StatusModalStates.LOADING);
      loadingModalTimeoutRef.current = setTimeout(() => {
        return resolve();
      }, LoadingModalTimeoutMs);
    });
  };

  const onPaymentSuccess = () => {
    onLoadingModal().then(() => {
      setProcessState(StatusModalStates.SUCCESS);

      successModalTimeoutRef.current = setTimeout(() => {
        closeProcessingModal();
        onSuccess();
      }, SuccessModalTimeoutMs);
    });
  };

  const onPaymentError = (
    _: string | Error | CoreError | StripeError,
    errorMsg?: string,
  ) => {
    setError(errorMsg);
    setProcessState(StatusModalStates.ERROR);
  };

  return {
    processState,
    error,
    onPaymentSuccess,
    onPaymentError,
    setProcessState,
    closeProcessingModal,
  };
};
